import React from "react";

export default function TermsConditions() {
  return (
    <div className="container-lookers py-16 max-w-2xl" data-testid="terms-conditions-page">
      <h1 className="font-serif text-5xl mb-8 text-zinc-900">
        Terms &amp; Conditions
      </h1>
      <div className="space-y-6 text-sm text-zinc-500 leading-relaxed">
        <p>By shopping with Lookers, you agree that every frame listed is preloved and individually inspected and condition rated before sale. Because each pair is one of a kind, once it's sold it may not be available again.</p>
        <p>Prices are shown in Australian dollars and include GST where applicable. Original RRP figures reflect the brand's original retail price and are provided for comparison only.</p>
        <p>Lens upgrades offered at checkout are clear, non-prescription lenses only — Lookers does not fit prescription lenses.</p>
        <p>Lookers reserves the right to cancel an order if a listed frame is found to be unavailable after purchase, in which case a full refund will be issued.</p>
      </div>
    </div>
  );
}
